import { useRef, useCallback, useLayoutEffect } from "react";

/*
 * Tells is the component using it is mounted
 *
 * Use it to avoid state updates on an unmounted component
 *
 * Example:
 *
 *  const isMounted = useIsMounted();
 *  const [dataState, setDataState] = useState();
 *
 *  useEffect(() => {
 *		apiCall().then((data) => {
 *			if(isMounted()) {
 *				setDataState(data);
 *			}
 *		})
 *  },[])
 *
 */
export default function useIsMounted() {
  const mountedRef = useRef(false);
  const isMounted = useCallback(() => mountedRef.current, []);

  useLayoutEffect(() => {
    mountedRef.current = true;

    return () => {
      mountedRef.current = false;
    };
  }, []);

  return isMounted;
}
